export function onDomReady(fn) {
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        setTimeout(fn, 1);
    } else {
        document.addEventListener('DOMContentLoaded', fn);
    }
}

export function onFullyLoaded(fn) {
    window.addEventListener('load', () => {
        fn();
    });
}

export function getMeta(metaName) {
    const metaEl = document.querySelector(`meta[name='${metaName}']`);
    if (!metaEl) {
        return '';
    }

    return metaEl.getAttribute('content');
}

export function setParam(name, values) {
    const searchParams = new URLSearchParams(window.location.search);
    if (values) {
        searchParams.set(name, values.toString());
    } else {
        searchParams.delete(name);
    }
    history.replaceState(null, null, '?'+searchParams.toString());
}

export function getParam(key) {
    const searchParams = new URLSearchParams(window.location.search);
    return searchParams.has(key) ? searchParams.get(key) : '';
}

export function capitalize(str) {
    return str.replace(/\b\w/g, char => char.toUpperCase());
}

export function isMobile() {
    return window.matchMedia("(max-width: 976px)").matches;
}